<section class="container">
	<div class="row py-5">
		<app-atom-change-password
			class="d-block col-12"
		></app-atom-change-password>
	</div>
</section>
